//List of icons and description items in the "how it works" view in receipt step.
import React, { useState } from "react"

import Modal from "@material-ui/core/Modal"
import DialogContent from "@material-ui/core/DialogContent"
import LegacyRetinaImage from "components/LegacyRetinaImage"
import { truncateStringByLine } from "util/misc"
import "./IconListItem.scss"


const IconListItemContent = props => {
  const { desc, headline, icon, iconType, svg="", iconBackgroundClr = "#3DA247", iconBorderClr = "#ffffff", detailHeadline, addDetails, openModal } = props
  
  const iconStyle = {backgroundColor: iconBackgroundClr, borderColor: iconBorderClr}
  const dynamicLinkProp = {
    onClick: () => {
      if (addDetails) {
        openModal(true)
      }
      
    }
  }
  // beaker data here is weird. if we have a svg content, that overrides definition
  const fixedType = (svg !=="") ? "SVG" : iconType

  return (
    <li className={`icon-list-item`}>
      {fixedType && (
        <div {...dynamicLinkProp} className={`icon-list-item-list-image ${addDetails ? 'has-detail-modal' : ' '}`}>
          {/* png image sourced from aws bucket */}
          {fixedType === "Image" && (
          <div className={`icon-list-item-image-icon icon-type-image`} style={iconStyle}>
            <LegacyRetinaImage image={{ id: icon.id, alt: icon.name }} />
          </div>
        )}
        {/* SVG markup embedded in beaker textarea field */}
         {(fixedType === "SVG" || svg !=="") && 
          <div className={`icon-list-item-image-icon icon-type-SVG`} style={iconStyle}>
            <div className="icon-list-item-svg-container" dangerouslySetInnerHTML={{ __html: svg }} ></div>
          </div>
        }
        {/* fontawesome icon */}
        {fixedType === "icon" && (
          <div className={`icon-list-item-image-icon icon-type-SVG`} style={iconStyle}>
            <div className="icon-list-item-svg-container" dangerouslySetInnerHTML={{ __html: svg }} ></div>
          </div>
        )}
        </div>
      )}
      <div className={`icon-list-item-text`}>
        <h3 className={`icon-list-item-headline`} dangerouslySetInnerHTML={{ __html: headline }}></h3>
        <div className={`icon-list-item-desc`}  dangerouslySetInnerHTML={{ __html: desc }} />{addDetails && <a onClick={ openModal} className={`icon-list-item-link`}>{detailHeadline}</a>}
      </div>
    </li>
  )
}

const IconListItem = props => {
  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  const { addDetails, desc, headline, detailDesc, detailBackgroundClr } = props
  const itemDescription = addDetails ? truncateStringByLine(desc, 2) : desc
  const style = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    backdropFilter: "blur(2px)",
  }

  return (
    <>
      {addDetails ? (
        <>
          <IconListItemContent openModal={handleOpen} {...props} />
          <Modal className={`icon-list-item-modal`} open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
            <DialogContent style={style}>
              <div className={`modal-wrap`}>
                <button className={`modal-close`} onClick={handleClose} aria-label="Close"></button>
                <div className={`modal-content-wrapper`}>
                  <div className={`modal-content-title`} dangerouslySetInnerHTML={{ __html: headline }} ></div>
                  <div className={`modal-content-description`} dangerouslySetInnerHTML={{ __html: detailDesc }} ></div>
                </div>
              </div>
            </DialogContent>
          </Modal>
        </>
      ) : (
        <IconListItemContent {...props} />
      )}
    </>
  )
}

export default IconListItem
